
import Vue from 'vue';
import { logout } from '../auth';

export default Vue.extend({
  name: 'LogoutButton',
  methods: {
    handleLogout() {
      logout();
      localStorage.removeItem('currentUser');
      this.$router.push('/login');
    }
  }
});
